<template>
<div>
  <div class="columns is-centered mt-6">
    <div class="column is-half">
      <div class="card">
        <div class="card-content">
          <div class="content  has-text-centered">
            <p class="title is-4 has-text-centered">Login Required</p>
            <p class="subtitle is-6">Please sign in</p>
            <div class="buttons is-centered mt-5">
              <a href="/saml/login" class="button is-link is-normal">
                <span class="icon">
                  <i class="fa fa-sign-in-alt"></i>
                </span>
                <span>TU Wien Login</span>
              </a>
            </div>
            <div class="mt-4">
              <button @click="showPasswordLogin = true" class="button is-ghost is-small is-text">
                Login with password
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="columns is-centered mt-4" v-if="showPasswordLogin">
    <div class="column is-half">
      <div class="card p-6">
        <div class="card-content columns is-centered">
          <Login :show-title="false" :is-one-third="false" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Login from '../../../src/components/Login.vue';

export default {
  components: {
    Login,
  },
  data() {
    return {
      showPasswordLogin: false,
    };
  },
  computed: {
    isLoggedin() {
      return this.$ctforge.state.loggedin;
    },
  },
  mounted() {
    if (this.isLoggedin) this.$router.push('/');
    document.title = 'Login';
  },
};
</script>

<style>
</style>
